import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { getStudentCurrentLesson } from "./api"

export const studentCurrentLessonQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentCurrentLesson', studentNo],
        queryFn: () => getStudentCurrentLesson(studentNo),
    })

export function useStudentCurrentLesson(studentNo: string) {
    return useQuery(studentCurrentLessonQueryOptions(studentNo))
}

export function useStudentCurrentLessonSuspense(studentNo: string) {
    return useSuspenseQuery(studentCurrentLessonQueryOptions(studentNo))
}
